import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import HeroOption1 from './HeroOption1/HeroOption1';
import NewsOverview from './NewsOverview/NewsOverview';
import NjitSearch from './Search/njitSearch';
import PhotoGallery from './PhotoGallery/PhotoGallery';
import FindYourCounselor from './FindYourCounselor/FindYourCounselor';
import NjitEquipment from './Equipment/njitEquipment';
import MakerspacePeople from './MakerspacePeople/MakerspacePeople'
import SiteLevelAlert from './SiteLevelAlert/SiteLevelAlert';
import Modal from './Modal/Modal'
import MobileMenu from './MobileMenu/MobileMenu'
import NjitProjectGrid from './ProjectGrid/njitProjectGrid';
import VirtualCommencementSelector from './VirtualCommencementSelector/VirtualCommencementSelector';
import WebSiteMap from './WebSiteMap';
import CountDownTimer from './CountDownTimer/index';
//import registerServiceWorker from './registerServiceWorker';

//import $ from 'jquery';
//import 'jquery-once';
//export for others scripts to use
//window.$ = $;
//window.jQuery = jQuery;
declare var jQuery: any;
declare var $: JQueryStatic;

console.log('version1');
(function ($) {

	$('.mobileMenu').each(function() {
		let dom = $(this)[0];
		ReactDOM.render(<MobileMenu data={dom.dataset}/>, dom);
	});

	$('.heroOption1').each(function() {
		let dom = $(this)[0];
		ReactDOM.render(<HeroOption1 data={dom.dataset}/>, dom);
	});

	$('.njitSearch').each(function() {
		let dom = $(this)[0];
		ReactDOM.render(<NjitSearch {...$(dom).data()} data={dom.dataset}/>, dom);
	});

	$('.newsOverview').each(function() {
		let dom = $(this)[0];
		ReactDOM.render(<NewsOverview data={dom.dataset}/>, dom);
	});

	$('.photoGallery').each(function() {
		let dom = $(this)[0];
		ReactDOM.render(<PhotoGallery {...$(dom).data()} data={dom.dataset}/>, dom);
	});

	$('.findYourCounselor').each(function() {
		let dom = $(this)[0];
		ReactDOM.render(<FindYourCounselor {...$(dom).data()} data={dom.dataset}/>, dom);
	});
	$('.njitEquipment').each(function() {
		let dom = $(this)[0];
		ReactDOM.render(<NjitEquipment {...$(dom).data()} data={dom.dataset}/>, dom);
	});
	$('.makerspacePeople').each(function() {
		let dom = $(this)[0];
		ReactDOM.render(<MakerspacePeople {...$(dom).data()} data={dom.dataset}/>, dom);
	});
	$('.siteLevelAlert').each(function() {
		let dom = $(this)[0];
		ReactDOM.render(<SiteLevelAlert {...$(dom).data()} data={dom.dataset}/>, dom);
	});
	$('.njit-modal').each(function() {
		let dom = $(this)[0];
		ReactDOM.render(<Modal {...$(dom).data()} data={dom.dataset}/>, dom);
	});
	$('.njitProjectGrid').each(function() {
		let dom = $(this)[0];
		ReactDOM.render(<NjitProjectGrid {...$(dom).data()} data={dom.dataset}/>, dom);
	});

	$('.njit-virtual-commencement-selector').each(function() {
		let dom = $(this)[0];
		ReactDOM.render(<VirtualCommencementSelector {...$(dom).data()} data={dom.dataset}/>, dom);
	});

	$('.websiteMap').each(function() {
		let dom = $(this)[0];
		ReactDOM.render(<WebSiteMap {...$(dom).data()} data={dom.dataset}/>, dom);
	});
	$('.CountDownTimer').each(function() {
		let dom = $(this)[0];
		ReactDOM.render(<CountDownTimer bootData={dom.dataset} />,dom);
	});

})(jQuery);


//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js